import { HttpService } from '@/shared/lib'

export class GetProdutoDisponivel extends HttpService {
  execute = async (idExternoProduto: number) => {
    return this.http.get<boolean>(`/api/v2/Produto/${idExternoProduto}/disponivelParaSimulacao`)
  }
}
